/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonProposalClosedListInfo } from '../models/BabylonProposalClosedListInfo';
import type { BabylonProposalClosedListRequest } from '../models/BabylonProposalClosedListRequest';
import type { BabylonProposalClosedTypeListInfo } from '../models/BabylonProposalClosedTypeListInfo';
import type { BabylonProposalDepositListInfo } from '../models/BabylonProposalDepositListInfo';
import type { BabylonProposalDepositListRequest } from '../models/BabylonProposalDepositListRequest';
import type { BabylonProposalDepositPeriodListInfo } from '../models/BabylonProposalDepositPeriodListInfo';
import type { BabylonProposalDetailInfo } from '../models/BabylonProposalDetailInfo';
import type { BabylonProposalDetailRequest } from '../models/BabylonProposalDetailRequest';
import type { BabylonProposalMessageListInfo } from '../models/BabylonProposalMessageListInfo';
import type { BabylonProposalMessageListRequest } from '../models/BabylonProposalMessageListRequest';
import type { BabylonProposalVoteStakerListInfo } from '../models/BabylonProposalVoteStakerListInfo';
import type { BabylonProposalVoteStakerListRequest } from '../models/BabylonProposalVoteStakerListRequest';
import type { BabylonProposalVoteValidatorListInfo } from '../models/BabylonProposalVoteValidatorListInfo';
import type { BabylonProposalVoteValidatorListRequest } from '../models/BabylonProposalVoteValidatorListRequest';
import type { BabylonProposalVotingPeriodListInfo } from '../models/BabylonProposalVotingPeriodListInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProposalControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalDetail({
        requestBody,
    }: {
        requestBody: BabylonProposalDetailRequest,
    }): CancelablePromise<BabylonProposalDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalVotingPeriodList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonProposalVotingPeriodListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/voting/period/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalVoteValidatorList({
        requestBody,
    }: {
        requestBody: BabylonProposalVoteValidatorListRequest,
    }): CancelablePromise<BabylonProposalVoteValidatorListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/vote/validator/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalVoteStakerList({
        requestBody,
    }: {
        requestBody: BabylonProposalVoteStakerListRequest,
    }): CancelablePromise<BabylonProposalVoteStakerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/vote/staker/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalMessageList({
        requestBody,
    }: {
        requestBody: BabylonProposalMessageListRequest,
    }): CancelablePromise<BabylonProposalMessageListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/message/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalDepositPeriodList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonProposalDepositPeriodListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/deposit/period/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalDepositList({
        requestBody,
    }: {
        requestBody: BabylonProposalDepositListRequest,
    }): CancelablePromise<BabylonProposalDepositListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/deposit/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalClosedTypeList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonProposalClosedTypeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/closed/type/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getProposalClosedList({
        requestBody,
    }: {
        requestBody: BabylonProposalClosedListRequest,
    }): CancelablePromise<BabylonProposalClosedListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/proposal/closed/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
